import { render, staticRenderFns } from "./employResume.vue?vue&type=template&id=35b7071f&scoped=true"
import script from "./employResume.vue?vue&type=script&lang=js"
export * from "./employResume.vue?vue&type=script&lang=js"
import style0 from "./employResume.vue?vue&type=style&index=0&id=35b7071f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b7071f",
  null
  
)

export default component.exports